module.exports = __webpack_public_path__ + "assets/img/btn-application-glay.3069a157.svg";